

















































































































































































import Vue from 'vue';
import http, { handleApiResponse } from "@/services/http";
import YellowConfirmation from "@/components/YellowConfirmation.vue";
import { ConfirmationMixin } from "@/mixins/confirmation";
import BookAuditItem, {BookAuditItemDefaultProps} from '../models/BookAuditItem';
import {AuditStatus} from '../models/BookAuditStatus';
import ApiResponse from "@/models/ApiResponse";
import auth from "../../../services/auth";
import eventBus from '@/services/eventBus';
import { SortDescriptor} from '@progress/kendo-data-query';
import { orderBy } from "@progress/kendo-data-query";
import store from '../services/TransactionStore';




interface Data{
    columns: any[];
    items: BookAuditItem[];
    selectedItem: BookAuditItem;
    auditStatuses: AuditStatus[];
    sort: SortDescriptor[];
}
interface Methods{
    onRowClick(item: any): void;
    cancel(): void;
    loadItems(): Promise<void>;
    generateXML(): void;
    openXML(): void;
    sortChangeHandler(e: any): void;
}
interface Computed{
    displayedItems: BookAuditItem[];
}
export default ConfirmationMixin.extend<Data,Methods,Computed,{}>({

    components: {
        YellowConfirmation,
    },

    mixins: [ConfirmationMixin],

    async beforeMount(){
        await this.loadItems();
        this.auditStatuses = await http.get<ApiResponse<AuditStatus[]>>("general-ledger-transaction/detail/get-audit-statuses").then(handleApiResponse);
    },
    data(){
        return{
            columns:[
                {field: 'fromDate', title: 'Dátumtól', className: 'right_text', width: '100px'},
                {field: 'toDate', title: 'Dátumig', className: 'right_text', width: '100px'},
                {field: 'insDate', title: 'Létrehozva', className: 'right_text', width: '110px'},
                {field: 'userName', title: 'Létrehozta'},
                {field: 'filename', title: 'Fájl neve'},
                {field: 'statusName', title: 'Állapot',},
                // {field: 'id', title: 'ID', width: '80px'},
            ],
            items: [],
            selectedItem:{
                    ...BookAuditItemDefaultProps,
                    user: auth.userID,
                    userName: auth.userName
            },
            auditStatuses: [],
            sort: [],

        }

    },
    methods:{
        onRowClick(event){
            this.selectedItem = event.dataItem;
        },
        cancel(){
            this.selectedItem = {
                    ...BookAuditItemDefaultProps,
                    user: auth.userID,
                    userName: auth.userName
            }
        },
        async loadItems(){
            this.items = await http.get<ApiResponse<BookAuditItem[]>>("general-ledger-transaction/auditxml/").then(handleApiResponse);
        },
        async generateXML(){
            if(!this.selectedItem.fromDate || !this.selectedItem.toDate){
                eventBus.$emit("error", "A dátumtartomány megadása kötelező!");
                return;
            }
            if(this.selectedItem.toDate < this.selectedItem.fromDate){
                eventBus.$emit("error", "A záró dátum nem lehet korábbi a kezdő dátumnál!");
                return;
            }
            // status 3 = Feldolgozva
            if(this.selectedItem.status == 3){
                const confirmed = await this.confirm("A kiválasztott állomány már feldolgozott. Biztosan újragenerálja?");
                if(!confirmed){
                    return;
                }
            }

            const res = await store.generateXML(this.selectedItem);

            // backend-hiba esetén a handleApiResponse már toastolt, a busyIndication pedig undefined-ot ad vissza
            if(!res){
                return;
            }

            if((res as any).success == false){
                eventBus.$emit("error", (res as any).message);
            }else{
                eventBus.$emit("success", (res as any).message);
                await this.loadItems();
            }
        },
        async openXML(){
            const res = await store.openXMLFile(this.selectedItem.filename)
            if (!res.data.success) {
                eventBus.$emit("error",  res.data.message);
            } else {
                eventBus.$emit("success", res.data.message);
            }
        },
        sortChangeHandler(e){
            this.sort = e.sort;
        }
    },
    computed:{
        displayedItems() {
            const mapped = this.items.map(item => ({
            ...item,
            selected: item.id === this.selectedItem?.id
            }));

            return orderBy(mapped, this.sort);
        }



    }
})

